import { lazy } from "react";
import { Route } from "../../../../routes";
const Information = lazy(() => import("./index"));
const PolicyForm = lazy(() => import("./Policy/PolicyForm"));

export const routes: Route[] = [
  {
    key: "policy",
    title: "Policy",
    path: "/policy",
    enabled: true,
    component: Information,
  },
  {
    key: "policy-form",
    title: "Policy Form",
    path: "/policy/new",
    enabled: true,
    component: PolicyForm,
  },
  {
    key: "policy-detail",
    title: "Policy Detail",
    path: "/policy/:id",
    enabled: true,
    component: PolicyForm,
  },
];
